module.exports = __webpack_public_path__ + "img/t3-14.7a916b17.svg";